import { useCallback } from 'react';

import { Button } from '../../components/core/button/Button';
import { useSwitchChain } from '../../hooks';
import { WEB3_CONFIG } from '../../lib';

export const WrongNetworkPage = () => {
  const { switchNetworkAsync } = useSwitchChain();

  const handleSwitchClick = useCallback(
    () => switchNetworkAsync?.(WEB3_CONFIG.chains.eth.id),
    [switchNetworkAsync],
  );

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <div className="flex flex-col items-center justify-center h-full max-w-screen-lg w-4/5">
        <p className="text-lg">You are using the wrong network ...</p>
        <Button className="mt-8" onClick={handleSwitchClick}>
          Switch To Mainnet
        </Button>
      </div>
    </div>
  );
};
